import { getEndState, getInitialState, handleEvents, startQuery } from './reducer-utils'
import { HistogramAction, HistogramState } from './types'

export const histogramReducer: WidgetReducerType<HistogramState, HistogramAction> = (
    state = getInitialState(),
    action
) => {
    switch (action?.type) {
        case 'start':
            return startQuery(action, state)

        case 'event':
            return handleEvents(action, state)

        case 'endHistory':
            return getEndState(action, state)
        default:
            return state
    }
}
